import { RecordType } from '@models';

export enum MapType {
  'aeronautical' = 'Aeronautical',
  'geological' = 'Geological',
  'nautical' = 'Nautical',
  'overview' = 'Overview',
  'sketch' = 'Sketch',
  'thematic' = 'Thematic',
  'topographic' = 'Topographic',
}

export enum MapLicense {
  'CC0' = 'CC0 1.0 Universal', // Released as Public Domain
  'CC-BY' = 'CC-BY 4.0 International',
  'copyright' = 'Copyright',
  'public domain' = 'Public Domain Mark 1.0', // Rights Expired
}

export enum PublicationType {
  'Single' = 'single',
  'Series' = 'series',
  'Set' = 'set',
}

export interface ScanDetails {
  code?: string;
  languages?: string[];
  license: MapLicense;
  publicationCountry?: string;
  publicationPlace?: string;
  publicationYear?: number;
}

export interface MapEntryDetails {
  preamble?: string;
  title: string;
  subtitle?: string;

  entryType: PublicationType;
  serie?: string;
  summary?: string;
  scales?: string[];
  mapType?: MapType;

  geojson?: GeoJSON.FeatureCollection;

  contributors: Contributor[];
  organisations: MapOrg[];
  scans?: Record<string, ScanDetails>;
}

export interface MapArchiveEntry {
  id: string;
  datasetId: string;
  type: RecordType;

  content: MapEntryDetails;

  createdBy: string;
  modifiedBy: string;
  publishedBy: string;
  created: string;
  modified: string;
  published: string;
}

export enum ContributorRole {
  Archivist = 'archivist',
  Cartographer = 'cartographer',
  Curator = 'curator',
  Originator = 'originator',
  Publisher = 'publisher',
  SuperIntendent = 'superintendent',
}

export interface Contributor {
  name: string;
  email?: string;

  roles: ContributorRole[];
}

export enum MapOrgRole {
  Archive = 'archive',
  Cartography = 'cartography',
  Originator = 'originator',
  Publisher = 'publisher',
}

export interface MapOrg {
  name: string;
  url?: string;

  roles: MapOrgRole[];

  // If The org is an archive this info can be provided. It's specific to the
  // org so therefore it's tracked as part of the org type.
  archiveInfo?: {
    copies?: number;
    room?: string;
    storageRef?: string;
  };
}
